import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, XCircle, Loader2 } from "lucide-react";
import client from "../lib/api";
import { trackEvent } from "../lib/tracking";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";

export default function PagamentoEsito({ ok = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(ok ? "checking" : "cancelled");
  const [course, setCourse] = useState("");

  useEffect(() => {
    if (!ok || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await client.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setCourse(data.lookup_key || "");
          trackEvent("purchase", { course: data.lookup_key });
          return;
        }
      } catch (err) {
        console.error("Errore nel polling dello stato pagamento:", err);
      }
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [ok, sessionId]);

  return (
    <div data-testid="payment-result-page" className="bg-nero min-h-screen flex items-center justify-center grain relative pt-24">
      <SEO title={ok ? "Pagamento" : "Pagamento annullato"} path="/pagamento" description="Esito del pagamento." />
      <div className="text-center px-5 max-w-xl">
        <Reveal>
          {status === "checking" && (
            <>
              <Loader2 size={36} className="text-oro mx-auto mb-6 animate-spin" />
              <h1 className="font-serif text-3xl font-bold text-panna">Conferma del pagamento in corso…</h1>
            </>
          )}
          {status === "paid" && (
            <>
              <div className="mx-auto h-16 w-16 rounded-full border-2 border-oliva flex items-center justify-center mb-8">
                <Check size={26} className="text-oliva" />
              </div>
              <h1 className="font-serif text-4xl font-bold text-panna" data-testid="payment-success-title">Pagamento confermato.</h1>
              <p className="mt-5 text-panna/70 leading-relaxed">
                Iscrizione completata. Riceverai via email i dettagli di accesso al corso.
                Per qualsiasi cosa: <a href="mailto:info@dentroilcalice.it" className="text-oro underline">info@dentroilcalice.it</a>
              </p>
            </>
          )}
          {status === "timeout" && (
            <>
              <Loader2 size={36} className="text-oro mx-auto mb-6" />
              <h1 className="font-serif text-3xl font-bold text-panna">Stiamo ancora verificando…</h1>
              <p className="mt-5 text-panna/70">Se il pagamento è andato a buon fine riceverai conferma via email a breve.</p>
            </>
          )}
          {status === "cancelled" && (
            <>
              <div className="mx-auto h-16 w-16 rounded-full border-2 border-bordeaux flex items-center justify-center mb-8">
                <XCircle size={26} className="text-bordeaux" />
              </div>
              <h1 className="font-serif text-4xl font-bold text-panna" data-testid="payment-cancelled-title">Pagamento annullato.</h1>
              <p className="mt-5 text-panna/70">Nessun addebito. Il corso ti aspetta quando vuoi.</p>
            </>
          )}
          <Link to="/corsi" data-testid="payment-back-courses"
                className="mt-10 inline-block rounded-full border border-oro/60 px-8 py-4 font-medium text-oro hover:bg-oro/10 transition-colors">
            Torna ai corsi
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
